var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21027",
    "data-name": "Grupo 21027",
    transform: "translate(11743 22117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2079",
    "data-name": "Rect\\xE1ngulo 2079",
    width: 28,
    height: 28,
    transform: "translate(-11743 -22117)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "add-browser-svgrepo-com",
    transform: "translate(-11740 -22113.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27545",
    "data-name": "Trazado 27545",
    d: "M3,11.541V21.595a2.514,2.514,0,0,0,2.514,2.514h7.541M3,11.541V6.514A2.514,2.514,0,0,1,5.514,4H23.108a2.514,2.514,0,0,1,2.514,2.514v5.027M3,11.541H25.622m0,0v3.77",
    transform: "translate(-3 -4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27546",
    "data-name": "Trazado 27546",
    d: "M17.77,14v3.77m0,3.77V17.77m0,0H14m3.77,0h3.77",
    transform: "translate(-0.176 -1.432)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_299",
    "data-name": "Elipse 299",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(2.417 2.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_300",
    "data-name": "Elipse 300",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(6.417 2.033)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNew);
export default __webpack_public_path__ + "static/media/icon-new.46059c20eecd8d6488a1c974b5050ddb.svg";
export { ForwardRef as ReactComponent };